module.exports = __webpack_public_path__ + "img/5-icono-cancelado-selecteds.4427b8a8.svg";